import { setTerms } from './helpers';

export const setPlacementType = setTerms('placement_type');
